import React from 'react';
import classes from './App.module.scss';
import Map from './Map';
import { useState, useEffect } from 'react';
import FormConsultant from './FormConsultant';
import { attachListeners } from '../assets/utilities';

export default function FormularRezervari({ type }) {
	const [firstRender, setFirstRender] = useState(true);

	useEffect(() => {
		if (firstRender) {
			attachListeners();
			setFirstRender(false);
		}
	}, []);

	const returnForm = () => {
		return (
			<>
				<div className={classes['slider-inner__form']}>
					<div className={`${classes['form__content']}`}>
						<FormConsultant version="consultant" />
					</div>
				</div>
				<Map center={{ lat: 46.673835, lng: 28.063628 }} location={{ lat: 46.673835, lng: 28.063628 }} zoom={14} />
			</>
		);
	};

	if (type === 'display_form') {
		return <div className={classes['form__content--display']}>{returnForm()}</div>;
	} else {
		return (
			<div className={classes.slider}>
				<div className={`${classes['slider__overlay']} split-banner__trigger-form`}></div>
				<div className={`${classes['slider__inner']} is-hidden`} id="app-formular-drawer">
					<button className={`${classes['slider-inner__close']} split-banner__trigger-form`}>&#10006;</button>
					<div className={classes['slider-inner__wrapper']}>
						<div className={classes['slider-inner__content']}>
							<img src="https://cdn.shopify.com/s/files/1/0126/3357/1392/files/frfrrf-removebg-preview.png?v=1682069140" alt="Bman" />
							<h3>Obține propriul consultant și croitor, în magazinul din Huși, GRATUIT!</h3>
							<span>
								<img src="https://cdn.shopify.com/s/files/1/0126/3357/1392/files/3754710_150x.png?v=1682068837" alt="Location"></img>
								Str. General Teleman 17
							</span>
						</div>
						{returnForm()}
					</div>
				</div>
			</div>
		);
	}
}
